require('../../../retail/js/feature/component-iframe');